import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import useQueryParams from "Utils/useQueryParams";
import SmallModal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import usePaginatedList from "Utils/usePaginatedList";
import { t } from "i18next";
import { addDomain as addDomainSvg, Icon, close } from "Icons";
import Checkbox from "Components/checkbox/Checkbox";
import XDate from "xdate";

const AddDeliveryAccountModal = ({
  isOpen = false,
  selectedAccountsCodes = [],
  customerCode = null,
  onButtonCancelClick,
  onButtonAcceptClick,
}) => {
  const queryParams = useQueryParams();
  const location = useLocation();
  const history = useHistory();

  const apiPath = `/delivery/accounts?${customerCode ? `customer_code=${customerCode}&` : ""}${queryParams.toString()}`;

  const { data, error } = usePaginatedList(apiPath);
  const [selectedAccounts, setSelectedAccounts] = useState({});

  const searchParams = useQueryParams();

  return (
    <SmallModal title={t("delivery.accounts.domainsPage.button.bindDomain")} opened={isOpen}>
      <div>
        <div className="sectionInfo">{t("delivery.accounts.domains.connectedDomains.modalMessage")}</div>
        <div className="mt-8">
          <PaginationFilter currentQuery={searchParams.query} />
          <div className="section">
            <ResponsiveTable
              location={location}
              areRowsLoading={!data || error}
              history={history}
              headers={[
                {
                  name: t("table.header.account"),
                  size: "15rem",
                },
                { name: t("table.header.code") },
              ]}
              rows={
                data
                  ? data.resources
                      .filter((accountData) => !selectedAccountsCodes?.includes(accountData.id))
                      .map((accountData) => (
                        <tr key={accountData.id}>
                          <td>
                            <Checkbox
                              name={accountData.description}
                              value={accountData.id}
                              //eslint-disable-next-line
                              onChange={(e) => {
                                if (selectedAccounts[accountData.id]) {
                                  const currentSelection = { ...selectedAccounts };
                                  delete currentSelection[accountData.id];

                                  setSelectedAccounts(currentSelection);
                                  return;
                                }

                                setSelectedAccounts({
                                  ...selectedAccounts,
                                  [accountData.id]: {
                                    id: accountData.id,
                                    description: accountData.description,
                                    status: accountData.status,
                                    status_detail: accountData.status_detail,
                                  },
                                });
                              }}
                              radioStyle
                              checked={selectedAccounts[accountData.id]}
                              valueOnly
                            />
                          </td>
                          <td>{accountData.id}</td>
                        </tr>
                      ))
                  : []
              }
              addIcon={addDomainSvg}
              addMsg={t("delivery.accounts.domains.noExistingDomain.msg")}
              addDesc={t("delivery.accounts.domains.noExistingDomain.desc")}
            />
          </div>
        </div>
        {/* <div className="section sectionDesc">
            {t("delivery.accounts.domains.connectedDomains.modalLabel")}: {selectedDomain && selectedDomain.name}
          </div> */}
        <div className="mt-8 flexEnd gap20 section expand">
          <Button
            color="outline"
            onClick={() => {
              onButtonCancelClick();
              setSelectedAccounts({});
            }}
          >
            button.cancel
          </Button>
          <Button
            disabled={Object.keys(selectedAccounts).length === 0}
            color="accent"
            onClick={() => {
              onButtonAcceptClick(selectedAccounts);
              setSelectedAccounts({});
            }}
          >
            button.add
          </Button>
        </div>
      </div>
    </SmallModal>
  );
};

export default AddDeliveryAccountModal;
